import { Tooltip } from "@excalidraw/excalidraw/components/Tooltip";
import { shield } from "@excalidraw/excalidraw/components/icons";
export const EncryptedIcon = () => {
  return (
    <span className="encrypted-icon tooltip" aria-label="End-to-end encrypted">
      <Tooltip
        label="Collaboration data is encrypted before it leaves your device."
        long={true}
      >
        {shield}
      </Tooltip>
    </span>
  );
};
